<template>
  <div class="container" v-if="data.flag">
    <button class="scan" @click="scanCode">扫一扫</button>
    <div class="reader-box" v-if="isScaning">
      <div class="reader" id="reader"></div>
    </div>
  </div>
</template>


<script>
import {
  Html5Qrcode
} from 'html5-qrcode';
export default {
  data() {
    return {
      code: '',
      html5Qrcode: null,
      isScaning: false,
    }
  },
  props: ['data'],
  methods: {
    startScan() {
      this.isScaning = true;
      let that = this;
      Html5Qrcode.getCameras().then(devices => {
        if (devices && devices.length) {
          that.html5Qrcode = new Html5Qrcode('reader');
          that.html5Qrcode.start({
            facingMode: 'environment',
          }, {
            fps: 24,
            qrbox: 280
          }, async (decodeText, decodeResult) => {
            if (decodeText) {
              console.log('decodeText', decodeText)
              that.stopScan(decodeText);
              that.isScaning = false;
            }
          }, (err) => {
            console.log(err)
          });
        }
      });
    },
    stopScan(decodeText) {
      this.html5Qrcode.stop();
      let obj = {
        submitFlag: true,
        code: decodeText
      }
      this.$emit("scanCall", obj);
    },
    scanCode() {
      this.startScan();
    }
  },
  watch: {
    data: {
      handler(newVal, oldVal) {
        if (newVal.flag) {
          this.startScan();
        } else {
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.container {
  height: 100%;
}

.reader-box {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.reader {
  width: 540rpx;
  height: 540rpx;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
